import styled from 'styled-components';
import { LinkButton as Button } from '../../../CommonComponents/Button';

const LinkButton = styled(Button)`
  color: #5abee4;
  font-size: 18px;
`;

export default LinkButton;
